<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Datos Maestros"
          directory="Visualizador de Solicitudes"
          :icon="'grid'"
        />
      </div>
    </div>

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3"></div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
  </div>
</template>
<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";

export default {
    extends: CoreLibrary,
    name: "ViewRequests",
    data() {
        return {
        tabsHorizontal: [
            {
                icon: "file-text",
                name: "LABORATORIOS",
                component: "view-request-laboratory",
                permission: "",
            },
            {
                icon: "file-text",
                name: "CERTIFICACIÓN",
                component: "view-request-certification",
                permission: "",
            },
            {
                icon: "file-text",
                name: "INSPECCIÓN",
                component: "view-request-inspection",
                permission: "",
            },
        ],
        };
    },
}
</script>

<style>

</style>